import axiosClient from "../../../../axiosClient"

const service = async () => {
    const result = await axiosClient.get(`/background-check-forms`)

    return result.data
}

export default service